const drill_es = require('./drill.json')
export default drill_es